module.exports = __webpack_public_path__ + "static/Lamentum3-cb68a888e57f06376f66137c29b99625.png";